module.exports = __webpack_public_path__ + "b4e267aace4e93175c6e5b2ecdc77278.svg";